import { createReducer, on } from '@ngrx/store';

import * as notificationPreferencesActions from '../actions/notification-preferences.actions';
import { notificationPreferencesState } from '../states/notification-preferences.state';

export const NOTIFICATION_PREFERENCES_REDUCER_KEY = 'notificationPreferences';

export const NOTIFICATION_PREFERENCES_REDUCER = createReducer(
    notificationPreferencesState,
    on(notificationPreferencesActions.SetUnsubscribeDetails, (state, action) => {
        return {
            ...state,
            unsubscribeDetails: action.unsubscribeDetails,
            unsubscribeSuccess: false,
        };
    }),
    on(notificationPreferencesActions.UnsubscribeEmailSuccess, state => {
        return {
            ...state,
            unsubscribeSuccess: true,
        };
    }),
    on(notificationPreferencesActions.SetEmailPreferences, (state, action) => {
        return {
            ...state,
            emailPreferences: action.emailPreferences,
            deleteSuccess: false,
        };
    }),
    on(notificationPreferencesActions.DeleteEmailPreferencesSuccess, state => {
        return {
            ...state,
            deleteSuccess: true,
        };
    }),
    on(notificationPreferencesActions.SetLoading, (state, action) => {
        return {
            ...state,
            loading: action.loading,
        };
    }),
    on(notificationPreferencesActions.SetError, (state, action) => {
        return {
            ...state,
            error: action.error,
        };
    }),
    on(notificationPreferencesActions.ResetNotificationPreferencesState, () => notificationPreferencesState)
);
